angular.module('postCenterWebClientApp').directive('darkModeToggle', darkModeToggle);

function darkModeToggle() {
    return {
        template: `
            <div class="dark-mode-toggle-container">
                <div class="dark-mode-config-title">
                    <div class="dark-mode-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8V16Z"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 4V8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16V20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"/>
                        </svg>
                    </div >
                    {{ 'DARK_MODE_ACTIVATE' | translate }}
                </div>
                <div class="dark-mode-toggle" ng-click="toggleDarkMode()">
                    <icon ng-class="{'active': !active}">
                        <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_48_3486)">
                                <path d="M10 0C9.5 0 9.16667 0.333333 9.16667 0.833333V1.66667C9.16667 2.16667 9.5 2.5 10 2.5C10.5 2.5 10.8333 2.16667 10.8333 1.66667V0.833333C10.8333 0.333333 10.5 0 10 0ZM3.49935 2.66602C3.29102 2.66602 3.08333 2.75 2.91667 2.91667C2.58333 3.25 2.58333 3.75033 2.91667 4.08366L3.49935 4.66634C3.83268 4.99967 4.33301 4.99967 4.66634 4.66634C4.99967 4.33301 4.99967 3.83268 4.66634 3.49935L4.08366 2.91667C3.91699 2.75 3.70768 2.66602 3.49935 2.66602ZM16.5007 2.66602C16.2923 2.66602 16.083 2.75 15.9163 2.91667L15.3337 3.49935C15.0003 3.83268 15.0003 4.33301 15.3337 4.66634C15.667 4.99967 16.1673 4.99967 16.5007 4.66634L17.0833 4.08366C17.4167 3.75033 17.4167 3.25 17.0833 2.91667C16.9167 2.75 16.709 2.66602 16.5007 2.66602ZM10 4.16667C8.4529 4.16667 6.96917 4.78125 5.87521 5.87521C4.78125 6.96917 4.16667 8.4529 4.16667 10C4.16667 11.5471 4.78125 13.0308 5.87521 14.1248C6.96917 15.2188 8.4529 15.8333 10 15.8333C11.5471 15.8333 13.0308 15.2188 14.1248 14.1248C15.2188 13.0308 15.8333 11.5471 15.8333 10C15.8333 8.4529 15.2188 6.96917 14.1248 5.87521C13.0308 4.78125 11.5471 4.16667 10 4.16667V4.16667ZM0.833333 9.16667C0.333333 9.16667 0 9.5 0 10C0 10.5 0.333333 10.8333 0.833333 10.8333H1.66667C2.16667 10.8333 2.5 10.5 2.5 10C2.5 9.5 2.16667 9.16667 1.66667 9.16667H0.833333ZM18.3333 9.16667C17.8333 9.16667 17.5 9.5 17.5 10C17.5 10.5 17.8333 10.8333 18.3333 10.8333H19.1667C19.6667 10.8333 20 10.5 20 10C20 9.5 19.6667 9.16667 19.1667 9.16667H18.3333ZM4.08366 15.083C3.87533 15.083 3.66602 15.167 3.49935 15.3337L2.91667 15.9163C2.58333 16.2497 2.58333 16.75 2.91667 17.0833C3.25 17.4167 3.75033 17.4167 4.08366 17.0833L4.66634 16.5007C4.99967 16.1673 4.99967 15.667 4.66634 15.3337C4.49967 15.167 4.29199 15.083 4.08366 15.083ZM15.9163 15.083C15.708 15.083 15.5003 15.167 15.3337 15.3337C15.0003 15.667 15.0003 16.1673 15.3337 16.5007L15.9163 17.0833C16.2497 17.4167 16.75 17.4167 17.0833 17.0833C17.4167 16.75 17.4167 16.2497 17.0833 15.9163L16.5007 15.3337C16.334 15.167 16.1247 15.083 15.9163 15.083ZM10 17.5C9.5 17.5 9.16667 17.8333 9.16667 18.3333V19.1667C9.16667 19.6667 9.5 20 10 20C10.5 20 10.8333 19.6667 10.8333 19.1667V18.3333C10.8333 17.8333 10.5 17.5 10 17.5Z"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_48_3486">
                                    <rect width="20" height="20"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </icon>
                    <div ng-class="{'toggle': true, 'active': active}">
                        <div class="inner-circle"></div>
                    </div>
                    <icon ng-class="{'active': active}">
                        <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.8491 18.3317C7.74165 18.3317 4.75498 16.5875 3.32248 13.6042C2.35915 11.5975 2.23498 9.33583 2.97331 7.23583C3.71165 5.13583 5.22331 3.44917 7.22998 2.48583C8.36248 1.94167 9.60915 1.6325 10.8666 1.66833C11.695 1.69167 11.9708 2.305 11.1883 2.76917C8.70498 4.2425 7.60415 8.255 8.81165 10.77C9.92665 13.0917 13.0766 15.6167 16.7008 14.29C17.185 14.1125 17.7675 14.6033 17.2783 15.28C16.5658 16.265 15.5375 16.985 14.4425 17.5108C13.2825 18.0675 12.0558 18.3308 10.8491 18.3317Z" fill="#DFE5E8"/>
                        </svg>                
                    </icon>
                </div>
            </div>
        `,
        restrict: 'E',
        controller: darkModeToggleCtrl
    }
}




darkModeToggleCtrl.$inject = ['$scope', '$rootScope', "FireTagService"];
function darkModeToggleCtrl($scope, $rootScope, FireTagService) {

    $scope.active = false;

    $scope.init = function() {
        const colorScheme = $scope.getPreferedColorScheme();
        $scope.setPreferedColorScheme(colorScheme);
        $scope.active = colorScheme === 'dark';
    }

    $scope.getPreferedColorScheme = () => {
        const explorerScheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const localStorageScheme = localStorage.getItem('colorScheme');
        switch (localStorageScheme) {
            case 'dark':
                return 'dark';
                
            case 'light':
                return 'light';
            default:
                return explorerScheme;
        }
    }

    $scope.setPreferedColorScheme = (scheme) => {
        localStorage.setItem('colorScheme', scheme);
        FireTagService.setEvent({
            name: 'set_color_scheme',
            params: {"scheme": scheme}
          });
        $rootScope.$emit('colorSchemeChanged', scheme);
    }

    $scope.toggleDarkMode = () => {
        $scope.active = !$scope.active;
        FireTagService.setEvent({
            name: 'color_scheme_active',
            params: {"is_active_dark_mode": $scope.active}
        });
        $scope.setPreferedColorScheme($scope.active ? 'dark' : 'light')
    }

    $scope.init();
}